import Paper from 'apollo-react/components/Paper';
import Table from 'apollo-react/components/Table';
import React from 'react';

import ActionCell from './ActionCell';
import { CustomHeader } from './CustomHeader';
import EditableCell from './EditableCell';
import { tablePaginationProps } from '../../components/FormattedTable';
import {
  compareStrings,
  createStringSearchFilter,
} from '../../components/SavedSearchesTable/utils';
import TextFieldFilter from '../../components/TableFilters/TextInputFilter';
import { useTranslation } from '../../custom-hooks/useTranslation';

const convertToString = (value) => (typeof value === 'number' ? value.toString() : value);

const convertRowProperties = (row, properties) => {
  return properties.reduce((acc, prop) => {
    acc[prop] = convertToString(row[prop]);
    return acc;
  }, {});
};

const ConfigureDataSourcesTable = ({
  rows,
  isLoading,
  onDelete,
  onOpenExternalDataSource,
  editRow,
  handleImportModalOpen,
  exportExternalDataSource,
  onSave,
  onAddRow,
  hasChanges,
  hasEmptyFields,
  title,
}) => {
  const translateString = useTranslation();

  const columns = [
    {
      header: translateString('Source'),
      accessor: 'source',
      sortFunction: compareStrings,
      customCell: EditableCell,
      filterFunction: createStringSearchFilter('source'),
      filterComponent: TextFieldFilter,
    },
    {
      header: translateString('Description'),
      accessor: 'description',
      sortFunction: compareStrings,
      customCell: EditableCell,
      filterFunction: createStringSearchFilter('description'),
      filterComponent: TextFieldFilter,
    },
    {
      header: translateString('SQL Query Statement'),
      accessor: 'query',
      sortFunction: compareStrings,
      customCell: EditableCell,
      filterFunction: createStringSearchFilter('query'),
      filterComponent: TextFieldFilter,
      width: '57%',
    },
    {
      header: translateString('Return To Column'),
      accessor: 'selectValueColumns',
      sortFunction: compareStrings,
      customCell: EditableCell,
      filterFunction: createStringSearchFilter('selectValueColumns'),
      filterComponent: TextFieldFilter,
    },
    {
      accessor: 'action',
      customCell: ActionCell,
      align: 'right',
      width: '6%',
    },
  ];

  return (
    <Paper square>
      <Table
        title={`${title} (${rows.length})`}
        isLoading={isLoading}
        columns={columns}
        rowId="id"
        rows={rows.map((row) => {
          const propertiesToConvert = ['source', 'description', 'query', 'selectValueColumns'];
          const convertedProperties = convertRowProperties(row, propertiesToConvert);

          return {
            ...row,
            ...convertedProperties,
            onDelete,
            onOpenExternalDataSource,
            editRow,
            editMode: row.editMode,
            editRowData: row.editRowData,
          };
        })}
        showFilterIcon
        initialSortOrder="asc"
        rowsPerPageOptions={[10, 20, 50, 100, translateString('All')]}
        defaultRowsPerPage={10}
        rowProps={{ hover: true }}
        filterTooltipText={translateString('Filter')}
        sortTooltipText={translateString('Sort')}
        filterButtonLabel={translateString('Filter')}
        tablePaginationProps={tablePaginationProps(translateString)}
        CustomHeader={CustomHeader}
        headerProps={{
          handleImportModalOpen,
          exportExternalDataSource,
          onSave,
          onAddRow,
          hasChanges: hasChanges && !hasEmptyFields,
        }}
      />
    </Paper>
  );
};

export default ConfigureDataSourcesTable;
